/**
 * Comprime a foto do comprovante (câmera do celular, muitas vezes vários MB)
 * pra um dataURL JPEG pequeno o bastante pra guardar no IndexedDB e trafegar
 * no corpo da sincronização offline (RF-VIA-04).
 */
const MAX_DIMENSION = 1280;
const JPEG_QUALITY = 0.72;

async function loadBitmapSource(file: File): Promise<ImageBitmap | HTMLImageElement> {
  if (typeof createImageBitmap === 'function') {
    return createImageBitmap(file);
  }
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Não foi possível ler a imagem selecionada'));
    };
    img.src = objectUrl;
  });
}

function sourceSize(source: ImageBitmap | HTMLImageElement): { width: number; height: number } {
  return 'width' in source && 'height' in source
    ? { width: source.width, height: source.height }
    : { width: 0, height: 0 };
}

export async function compressPhotoToDataUrl(file: File): Promise<string> {
  const source = await loadBitmapSource(file);
  const { width: rawWidth, height: rawHeight } = sourceSize(source);
  const scale = Math.min(1, MAX_DIMENSION / Math.max(rawWidth, rawHeight, 1));
  const width = Math.max(1, Math.round(rawWidth * scale));
  const height = Math.max(1, Math.round(rawHeight * scale));

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Este dispositivo não suporta processamento de imagem (canvas 2D)');
  }
  ctx.drawImage(source, 0, 0, width, height);
  if ('close' in source) {
    source.close();
  }
  return canvas.toDataURL('image/jpeg', JPEG_QUALITY);
}
